// Shared by build-gantt-pdf.tsx and GanttPdfDocument.tsx, which otherwise
// import each other (the document component's own JSX, the layout function's
// use of the component to render) — a third module they both import from
// keeps that a one-directional dependency instead of a cycle.

// A4 landscape in points, matching <Page size="A4" orientation="landscape">
// in GanttPdfDocument, minus that page's own `padding: 24` on every side.
export const PAGE_WIDTH_PT = 841.89
export const PAGE_HEIGHT_PT = 595.28
export const PAGE_PADDING_PT = 24
export const USABLE_WIDTH_PT = PAGE_WIDTH_PT - 2 * PAGE_PADDING_PT
export const USABLE_HEIGHT_PT = PAGE_HEIGHT_PT - 2 * PAGE_PADDING_PT

// Reserved height for the title/subtitle/meta/legend block above the two
// images — a fixed estimate, not a measurement of the real render.
//
// Sized for today's 5-entry legend (GanttPdfDocument's STATUS_LABELS) on one
// wrapped row. @react-pdf/renderer offers no way to measure the real render
// before laying out the page below it, so this can't self-correct: adding a
// 6th MilestoneStatuses value (a compile error in STATUS_LABELS forces you
// here) can push the legend onto a second wrapped line, and this constant
// has to grow to match or the page-overflow bug this file's layout math
// exists to prevent comes back silently.
export const HEADER_BLOCK_HEIGHT_PT = 130
export const AVAILABLE_ROW_HEIGHT_PT = USABLE_HEIGHT_PT - HEADER_BLOCK_HEIGHT_PT

export const IMAGE_GAP_PT = 8

export interface GanttPdfImageLayout {
  leftPanelWidth: number
  leftPanelHeight: number
  chartWidth: number
  chartHeight: number
}

export interface GanttPdfLayoutResult {
  layout: GanttPdfImageLayout
  scaledDown: boolean
}
